import { all, spawn } from 'redux-saga/effects';
import soundflySaga from 'store/sagas';

export default function* root() {
  yield all([spawn(soundflySaga)]);
}
